module.exports = __webpack_public_path__ + "img/unfollow.32e79838.svg";